import {HttpClient, HttpParams} from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {Injectable} from "@angular/core";
import {tap} from "rxjs/operators";
import {DefaultService} from "../../shared/_services/abstract/default.service";

@Injectable()
export class StationsService extends DefaultService {

    link: any;
    filters: any = {};
    onItemUpdate: BehaviorSubject<any>;
    onSearchTextChanged: Subject<any>;
    constructor(public override http: HttpClient) {
        super(http);
        this.setResourceLink('stations');
        this.onItemUpdate = new BehaviorSubject([]);
        this.onSearchTextChanged = new Subject();

    }

    public getOrderInfo(queryParams: any): Observable<any> {
            return this.http.post(this.endpoint + this.resourceLink, queryParams)
                .pipe(
                    tap((data: any) => {
                           console.log('data',data)

                        },
                        err => {

                            console.log('aa',err.error.errors)

                        }
                    ))


        }

}
